@import 'styles/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  background-color: $white;
  min-height: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main {
  margin: 0 auto;
  width: 100%;
  max-width: 1024px;
  display: flex;
  flex-grow: 1;
  align-items: center;
  flex-direction: column;

  @include for-tablet-portrait-down {
    flex-direction: column;
  }
}

.mostCopiedContainer {
  margin: 0 -44px 44px;
  padding: 0 46px 44px;

  @include for-phone-only {
    margin: 0;
    padding: 32px 10px 44px 10px;
  }
}

.contributorContainer {
  background: linear-gradient(180deg, #fafafa 0%, rgba(246, 250, 251, 0) 100%);
  margin: 0 -44px 0;
  padding: 46px 44px;

  @include for-phone-only {
    margin: 0;
    padding: 32px 10px 44px 10px;
  }
}

.contributorSectionTitleOverrides {
  margin-bottom: 24px;
}

.samlAuthMessage,
.googleAuthMessage {
  display: flex;
  align-items: center;
  justify-content: center;
}

.chevronRight {
  margin: 0 10px;
}

.noResultsMessageContainer {
  margin: 0 -44px 44px;
  padding: 46px 0;
  width: 100%;

  @include for-phone-only {
    margin: 0;
    padding: 10px;
  }
}

.searchSpinner {
  flex-grow: 1;
  display: flex;
  align-items: center;
  min-height: 100px;
}

.coreContent {
  margin-top: 44px;

  @include for-phone-only {
    margin-top: 0;
  }
}

.noResultsHeader {
  @include sm-regular;

  text-transform: uppercase;
  color: $gray-40;
  margin-bottom: 8px;

  @include for-phone-only {
    margin-bottom: 12px;
  }
}

.noResultsMessage {
  @include publico-light;
  font-size: 32px;
  color: $gray-50;
  margin: 0;
}
